const setLoadingState = (form, disable = true) => {
  let $submit_button = $(form).find('button[type="submit"]');
  $submit_button = $submit_button.length ? $submit_button : $(form).find('input[type="submit"]');

  if (disable) {
    $submit_button.prop('disabled', true);
  } else {
    $submit_button.prop('disabled', false);
  }
};

const datepicker = (container = document) => {
  $('[data-datepicker]', container).datepicker({
    maxDate: 0,
    dateFormat: 'yy-mm-dd',
  });
};
const getUrlVariables = () => {
  const vars = {};
  window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, (m, key, value) => {
    vars[key] = value;
  });
  return vars;
};

const getUrlParameters = (parameter, defaultvalue) => {
  let urlparameter = defaultvalue;
  if (window.location.href.indexOf(parameter) > -1) {
    urlparameter = getUrlVariables()[parameter];
  }
  return urlparameter;
};

const validateFileUpload = (input_element) => {
  const allowed_extensions = ['jpg', 'jpeg', 'png', 'gif', 'pdf'];
  let is_valid = false;
  let message = '';

  // Check extensions
  _.each(input_element.files, (file) => {
    const file_extension = file.name.split('.').pop().toLowerCase();
    // _.each(allowed_extensions, (extension) => {
    //   if (extension === file_extension) {
    //     is_valid = true;
    //     return;
    //   }
    //   is_valid = false;
    // });
    if (allowed_extensions.includes(file_extension)) {
      is_valid = true;
    } else {
      is_valid = false;
      message += `File: ${file.name} is not an image. \n`;
    }
  });

  // Check file size
  _.each(input_element.files, (file) => {
    const file_size = (file.size / 1024 / 1024).toFixed(4);
    if (file_size > 100) {
      is_valid = false;
      message += `File: ${file.name} size is greater than 100 MB. \n`;
    }
  });

  return { is_valid, message };
};

const handleFileUpload = (e) => {
  const label = e.currentTarget.nextElementSibling;
  const label_value = label.innerHTML;
  const file_data = validateFileUpload(e.target);

  if (!file_data.is_valid) {
    // eslint-disable-next-line
    alert(file_data.message);
    return false;
  }

  let fileName = '';

  if (e.target.files && e.target.files.length > 1) {
    fileName = ($(e.currentTarget).data('multiple-caption') || '').replace('{count}', e.target.files.length);
  } else {
    //    fileName = e.target.value.split('\\').pop();
    fileName = `1 ${window.theme.file_selected_copy}`;
  }

  if (fileName) {
    label.querySelector('span').innerHTML = fileName;
  } else {
    label.innerHTML = label_value;
  }

  return true;
};

const sendWebForm = (data) => {
  const url = `${window.theme.sh_webform_url}`;
  return $.post({
    url,
    data,
    async: true,
    cache: false,
    contentType: false,
    enctype: 'multipart/form-data',
    processData: false,
    crossDomain: true,
  });
};

const showSpinner = (show) => {
  const spinner = document.querySelector('.spinner');

  if (show) {
    spinner.style.display = 'block';
  } else {
    spinner.style.display = 'none';
  }
};

const sendApiRequest = (host, jsonData, path) => {
  const url = `https://${host}/${path}`;
  return $.post({
    url,
    async: true,
    cache: false,
    contentType: 'application/json',
    processData: false,
    crossDomain: true,
    data: jsonData,
  });
};

// create function productInformationLookup which takes in jsonData parameterexport
const productInformationLookup = (jsonData, longForm = true, formObject = false) => {
  $('#error_serialNumber').hide();
  sendApiRequest(window.theme.sh_api_domain, jsonData, 'v1/shopify/registration-product-lookup/')
    .then((response) => {
      if (response.data.serial_number.error_code == 'exists' || response.data.serial_number.error_code == 'invalid') {
        $('#error_serialNumber').html(response.data.serial_number.error);
        $('#error_serialNumber').show();
      } else if (response.data.product.error !== '' && longForm) {
        $('#error_productSku').html(response.data.product.error);
        $('#error_productSku').show();
      } else if (response.data.product.error == '' && !longForm) {
        // get form object and submit
        formObject.submit();
      } else if (response.data.product.error == '' && longForm) {
        const newsletter_signup = document.querySelector('#newsletter_signup').textContent;
        const percent_off_message = document.querySelector('#percent_off_message').textContent;
        const with_this_registration = document.querySelector('#with_this_registration').textContent;

        if (window.theme.enable_new_registration_flow) {
          $('#addToEmailListCopy').hide();
        } else {
          $('#addToEmailListCopy').html(newsletter_signup);
        }

        const sku = response.data.product.sku;
        const product_name = response.data.product.product_name;
        const warranty_years = response.data.product.warranty_years;
        const serial_required = response.data.product.serial_required;
        const upc = response.data.product.upc;
        const liner_code = response.data.product.liner_code;
        const product_type = response.data.product.product_type;
        const registration_product_type = response.data.product.registration_product_type;
        const support_collection = response.data.product.support_collection;

        //          $(e.currentTarget).html(response.success);
        //get modelSKU element id
        //          const modelSKU = document.getElementById('modelSKU');
        // set value of modelSKU to sku
        //          modelSKU.value = sku;
        //          const productImage = document.getElementById('productImage');
        $('#linerSize').val(liner_code);
        $('#modelUPC').val(upc);
        $('#modelSKU').val(sku);
        $('#warrantyYears').val(warranty_years);
        if ($('#supportCollection').length) {
          $('#supportCollection').val(support_collection + '?view=warranty');
        }
        $('#productType').val(product_type);
        // if element id "productImage" exists, then set the image
        if ($('#productImage').length) {
          $('#productImage').attr('src', '//s3cdn.simplehuman.com/media/main_images/main-' + sku + '.jpg');
          // show element
          $('#divProductImageWrapper').show();
        }
        if ($('#contine-to-warranty-claim-link').length) {
          // set href of element to support_collection
          $('#contine-to-warranty-claim-link').attr('href', support_collection + '?view=warranty');
        }
        $('#productNameReg').val(product_name);
        // html of #divProductName set
        $('#divProductName').html(product_name);
        // if data.serial.error exists

        const serialRequired = document.getElementById('serialRequired');
        if (serial_required == 1) {
          if (response.data.serial_number.id != '') {
            if (window.theme.enable_new_registration_flow) {
              $('#addToEmailListCopy')
                .html('<span class="Text-Style--bold">' + percent_off_message + '</span> ')
                .show();
            } else {
              $('#addToEmailListCopy').html(
                '<span class="Text-Style--bold">' + percent_off_message + '</span> ' + with_this_registration
              );
            }
          }

          //set value of serialRequired to 1
          serialRequired.value = 1;
        } else {
          $('.divSerialNumber').hide();
          console.log('divSerialNumberLocationWrapper');
          // get element id divSerialNumberLocationWrapper
          const divSerialNumberLocationWrapper = document.getElementById('divSerialNumberLocationWrapper');
          // set visibility to hidden
          divSerialNumberLocationWrapper.style.visibility = 'hidden';
          if (window.theme.enable_new_registration_flow) {
            $('#addToEmailListCopy').hide();
          } else {
            $('#addToEmailListCopy').html(newsletter_signup).hide();
          }
          //set value of serialRequired to 1
          serialRequired.value = 0;
        }

        if ($('#serialNumberLocationImage').length && registration_product_type != '') {
          $('#serialNumberLocationImage').attr(
            'src',
            '//cdn.shopify.com/s/files/1/2804/6630/files/serial_number_location-' + registration_product_type + '.jpg'
          );
          // show element
          $('#divSerialNumberLocationWrapper').show();
        }
      } else if (response.error !== '') {
        console.log(response.error);
        //          $(e.currentTarget).html(response.error);
      } else {
        setTimeout(() => $(e.currentTarget).css({ 'pointer-events': 'auto', cursor: 'pointer' }), 500);
      }

      //        return true;
    })
    .catch((error) => console.log(error));
};

const setBindings = ($container) => {
  $('[data-product-registration-state]', $container).on('change', (e) => {
    e.preventDefault();
    $('.state_select').css('color', '#4A4A4A');
  });

  $('[data-product-registration-retailer]', $container).on('change', (e) => {
    e.preventDefault();
    $('.retailer_select').css('color', '#4A4A4A');
  });

  $('[data-register-another]', $container).on('click', (e) => {
    e.preventDefault();

    $('#productSelector').val('');
    $('#serialNumber').val('');
    $('#productType').val('');
    $('#linerSize').val('');
    $('#modelUPC').val('');
    $('#modelSKU').val('');
    $('#productNameReg').val('');

    if ($('#receipt_upload_label').length > 0) {
      $('#receipt_upload_label').html(window.theme.choose_file_copy);
    }

    if ($('#retailer').length > 0) {
      $('#retailer').val('');
    }

    $('#serialNumber').trigger('focusout');
    // $('#addToEmailListCopy').html("sign up for exclusive offers and early access to new products");
    $('.serialCol').hide();
    $('#block2').hide();
    $('#block3').hide();
    $('#block1').show();
  });

  $('[data-product-registration-form]', $container).submit((e) => {
    e.preventDefault();
    setLoadingState(e.currentTarget);

    const form_data = new FormData(e.currentTarget);

    sendWebForm(form_data)
      .then((response) => {
        $('.validation-advice').hide();
        setLoadingState(e.currentTarget, false);

        if (response.success !== '') {
          // const $modal = $('#webForm').closest('.modal-inner-wrap');
          // $modal.find('.modal-title').hide();
          // $modal.find('.modal-footer').hide();
          $('html, body').animate({ scrollTop: $('#productRegistration').offset().top - 80 }, 'slow');

          // $("html, body").animate({ scrollTop: 0 }, "slow");
          $('#block1').hide();
          $('#block2').html(response.success);
          $('#block2').show();
          $('#block3').show();
          $('#Module-Banner--1').hide();
          $('#Module-HeadingText--0').hide();
          $('#Module-Cards--0').hide();
          $('.successBlock').show();

          if ($('.Warranty__address').length) {
            $('#justRegistered').val('1');
            $('[data-warranty-claim-form] input[name^="firstName"]').val(
              $('[data-product-registration-form] input[name^="firstName"]').val()
            );
            $('[data-warranty-claim-form] input[name^="lastName"]').val(
              $('[data-product-registration-form] input[name^="lastName"]').val()
            );
            $('[data-warranty-claim-form] input[name^="email"]').val(
              $('[data-product-registration-form] input[name^="email"]').val()
            );
            $('[data-warranty-claim-form] input[name^="phone"]').val(
              $('[data-product-registration-form] input[name^="phone"]').val()
            );
            $('[data-warranty-claim-form] input[name^="address1"]').val(
              $('[data-product-registration-form] input[name^="address1"]').val()
            );
            $('[data-warranty-claim-form] input[name^="address2"]').val(
              $('[data-product-registration-form] input[name^="address2"]').val()
            );
            $('[data-warranty-claim-form] input[name^="city"]').val(
              $('[data-product-registration-form] input[name^="city"]').val()
            );
            $('[data-warranty-claim-form] .state_select').val(
              $('[data-product-registration-form] .state_select').val()
            );
            $('[data-warranty-claim-form] input[name^="zipcode"]').val(
              $('[data-product-registration-form] input[name^="zipcode"]').val()
            );
            $('[data-warranty-claim-form] input[name^="country"]').val(
              $('[data-product-registration-form] input[name^="country"]').val()
            );
            $('.Warranty__address').hide();
          }
        } else {
          if (response.error_email !== '') {
            $('#error_email').html(response.error_email);
            $('#error_email').show();
          }
          if (response.error_phone !== '') {
            $('#error_phone').html(response.error_phone);
            $('#error_phone').show();
          }
          if (response.error_firstName !== '') {
            $('#error_firstName').html(response.error_firstName);
            $('#error_firstName').show();
          }
          if (response.error_lastName !== '') {
            $('#error_lastName').html(response.error_lastName);
            $('#error_lastName').show();
          }
          if (response.error_address1 !== '') {
            $('#error_address1').html(response.error_address1);
            $('#error_address1').show();
          }
          if (response.error_city !== '') {
            $('#error_city').html(response.error_city);
            $('#error_city').show();
          }
          if (response.error_state !== '') {
            $('#error_state').html(response.error_state);
            $('#error_state').show();
          }
          if (response.error_zipcode !== '') {
            $('#error_zipcode').html(response.error_zipcode);
            $('#error_zipcode').show();
          }
          if (response.error_modelUPC !== '') {
            $('#error_modelUPC').html(response.error_modelUPC);
            $('#error_modelUPC').show();
          }
          if (response.error_retailer !== '') {
            $('#error_retailer').html(response.error_retailer);
            $('#error_retailer').show();
          }
          if (response.error_serialNumber !== '') {
            $('#error_serialNumber').html(response.error_serialNumber);
            $('#error_serialNumber').show();
          }
          if (response.error_purchaseDate !== '') {
            $('#error_purchaseDate').html(response.error_purchaseDate);
            $('#error_purchaseDate').show();
          }
          if (response.error_subject !== '') {
            $('#error_subject').html(response.error_subject);
            $('#error_subject').show();
          }
          if (response.error_orderNumber !== '') {
            $('#error_orderNumber').html(response.error_orderNumber);
            $('#error_orderNumber').show();
          }
          if (response.error_questionProblem !== '') {
            $('#error_questionProblem').html(response.error_questionProblem);
            $('#error_questionProblem').show();
          }
          if (response.error_invoiceNumber !== '') {
            $('#error_invoiceNumber').html(response.error_invoiceNumber);
            $('#error_invoiceNumber').show();
          }
          if (response.error_numberPackages !== '') {
            $('#error_numberPackages').html(response.error_numberPackages);
            $('#error_numberPackages').show();
          }
          if (response.error_popup !== '') {
            if ($('#errorModal').length) {
              $('#error_popup').html(response.error_popup);
              $('a#showErrorModal').trigger('click');
            }
          }
          if (response.error_productType !== '') {
            $('#error_productType').html(response.error_productType);
            $('#error_productType').show();
          }
          if (response.error_fileUpload !== '') {
            $('#error_fileUpload').html(response.error_fileUpload);
            $('#error_fileUpload').show();
          }
          if ($('.please-wait').length) {
            $('.please-wait').hide();
          }
          $('button').removeClass('link_clicked');
          if ($('#submitForm').length) {
            $('#submitForm').removeAttr('disabled');
          }
        }
        return true;
      })
      .catch((error) => console.log(error));
  });

  const $file_inputs = $('[data-input-file]', $container);
  _.each($file_inputs, (input) => {
    $(input).on('change', handleFileUpload);
  });
};

const setBindingsNewFlow = ($container) => {
  const country_code = window.theme.country_code;

  const start_warranty_flow = window.sessionStorage.getItem('start_warranty_flow');
  if (start_warranty_flow === 'true' && $('#continueToWarrantyClaim').length) {
    $('#continueToWarrantyClaim').val('1');
  }

  const sku = getUrlParameters('sku', '');
  const serial_number = getUrlParameters('sn', '');

  if (sku !== '' || serial_number !== '') {
    if (sku !== '') {
      $('#modelSKU').val(sku);
    }
    if (serial_number !== '') {
      $('#serialNumber').val(serial_number);
      $('#serialNumber').css('height', '0');
      $('#serialNumber').css('visibility', 'hidden');
    }

    // const productSelector = document.getElementById('productSelector');
    // productSelector.value = sku;

    const jsonData = JSON.stringify({
      sku,
      serial_number,
      country: country_code,
    });

    productInformationLookup(jsonData, true, false);
  } else {
    window.location.href = `${Shopify.routes.root}account?view=registrations`;
  }

  $('#serialNumber')
    .focusout(function (event) {
      console.log('serialNumber focusout');
      const newsletter_signup = document.querySelector('#newsletter_signup').textContent;

      if (window.theme.enable_new_registration_flow) {
        $('#addToEmailListCopy').hide();
      } else {
        $('#addToEmailListCopy').html(newsletter_signup);
      }

      if ($(this).val() === '') {
        return;
      }

      event.preventDefault();

      // let boolValidSerialNumber = false;
      const regSerialNumber = /[a-zA-Z]{1}[0-9]{8}/;

      // eslint-disable-next-line no-negated-condition
      if (!regSerialNumber.test($(this).val())) {
        $('#error_serialNumber').html('This serial number is invalid.');
        $('#serialNumber').css('height', 'auto');
        $('#serialNumber').css('visibility', 'visible');
        $('#error_serialNumber').show();
      } else {
        const jsonData = JSON.stringify({
          sku: document.querySelector('#modelSKU').value,
          serial_number: document.querySelector('#serialNumber').value,
          country: country_code,
        });

        console.log(jsonData);

        productInformationLookup(jsonData, true, false);
      }
    })
    .trigger('focusout');

  $('[data-product-registration-state]', $container).on('change', (e) => {
    e.preventDefault();

    $('.state_select').css('color', '#4A4A4A');
  });

  $('[data-product-registration-retailer]', $container).on('change', (e) => {
    e.preventDefault();

    $('.retailer_select').css('color', '#4A4A4A');
  });

  $('[data-register-another]', $container).on('click', (e) => {
    e.preventDefault();

    $('#productSelector').val('');
    $('#serialNumber').val('');
    $('#productType').val('');
    $('#linerSize').val('');
    $('#modelUPC').val('');
    $('#modelSKU').val('');
    $('#warrantyYears').val('');
    $('#productNameReg').val('');

    if ($('#receipt_upload_label').length > 0) {
      $('#receipt_upload_label').html(window.theme.choose_file_copy);
    }

    if ($('#retailer').length > 0) {
      $('#retailer').val('');
    }

    $('#serialNumber').trigger('focusout');
    // $('#addToEmailListCopy').html("sign up for exclusive offers and early access to new products");
    // $('.serialCol').hide();
    $('#block2').hide();
    $('#block3').hide();

    if ($('#divContinueToWarrantyClaim').length) {
      $('#divContinueToWarrantyClaim').hide();
    }

    $('#block1').show();
  });

  $('[data-product-registration-form]', $container).submit((e) => {
    e.preventDefault();

    setLoadingState(e.currentTarget);
    showSpinner(true);

    const form_data = new FormData(e.currentTarget);
    sendWebForm(form_data)
      .then((response) => {
        $('.validation-advice').hide();

        // eslint-disable-next-line no-negated-condition
        if (response.success !== '') {
          window.location.href = `${Shopify.routes.root}account?view=registrations`;
        } else {
          setLoadingState(e.currentTarget, false);
          showSpinner(false);

          if (response.error_email !== '') {
            $('#error_email').html(response.error_email);
            $('#error_email').show();
          }

          if (response.error_phone !== '') {
            $('#error_phone').html(response.error_phone);
            $('#error_phone').show();
          }

          if (response.error_firstName !== '') {
            $('#error_firstName').html(response.error_firstName);
            $('#error_firstName').show();
          }

          if (response.error_lastName !== '') {
            $('#error_lastName').html(response.error_lastName);
            $('#error_lastName').show();
          }

          if (response.error_address1 !== '') {
            $('#error_address1').html(response.error_address1);
            $('#error_address1').show();
          }

          if (response.error_city !== '') {
            $('#error_city').html(response.error_city);
            $('#error_city').show();
          }

          if (response.error_state !== '') {
            $('#error_state').html(response.error_state);
            $('#error_state').show();
          }

          if (response.error_zipcode !== '') {
            $('#error_zipcode').html(response.error_zipcode);
            $('#error_zipcode').show();
          }

          if (response.error_modelUPC !== '') {
            $('#error_modelUPC').html(response.error_modelUPC);
            $('#error_modelUPC').show();
          }

          if (response.error_retailer !== '') {
            $('#error_retailer').html(response.error_retailer);
            $('#error_retailer').show();
          }

          if (response.error_serialNumber !== '') {
            $('#error_serialNumber').html(response.error_serialNumber);
            $('#error_serialNumber').show();
          }

          if (response.error_purchaseDate !== '') {
            $('#error_purchaseDate').html(response.error_purchaseDate);
            $('#error_purchaseDate').show();
          }

          if (response.error_subject !== '') {
            $('#error_subject').html(response.error_subject);
            $('#error_subject').show();
          }

          if (response.error_orderNumber !== '') {
            $('#error_orderNumber').html(response.error_orderNumber);
            $('#error_orderNumber').show();
          }

          if (response.error_questionProblem !== '') {
            $('#error_questionProblem').html(response.error_questionProblem);
            $('#error_questionProblem').show();
          }

          if (response.error_invoiceNumber !== '') {
            $('#error_invoiceNumber').html(response.error_invoiceNumber);
            $('#error_invoiceNumber').show();
          }

          if (response.error_numberPackages !== '') {
            $('#error_numberPackages').html(response.error_numberPackages);
            $('#error_numberPackages').show();
          }

          if (response.error_popup !== '') {
            if ($('#errorModal').length) {
              $('#error_popup').html(response.error_popup);
              $('a#showErrorModal').trigger('click');
            }
          }

          if (response.error_productType !== '') {
            $('#error_productType').html(response.error_productType);
            $('#error_productType').show();
          }

          if (response.error_fileUpload !== '') {
            $('#error_fileUpload').html(response.error_fileUpload);
            $('#error_fileUpload').show();
          }

          if ($('.please-wait').length) {
            $('.please-wait').hide();
          }

          $('button').removeClass('link_clicked');

          if ($('#submitForm').length) {
            $('#submitForm').removeAttr('disabled');
          }
        }
        return true;
      })
      .catch((error) => console.log(error));
  });

  const $file_inputs = $('[data-input-file]', $container);
  _.each($file_inputs, (input) => {
    $(input).on('change', handleFileUpload);
  });
};

/* eslint-disable */
const generateProductDD = (jFile) => {
  $.getJSON(jFile, function (data) {
    const error_item_empty = document.querySelector('#error_item_empty').textContent;
    const error_item_partial = document.querySelector('#error_item_partial').textContent;
    const serial_number_format = document.querySelector('#serial_number_format').textContent;

    const products = $.map(data, function (item) {
      return {
        sku: item.sku,
        name: item.name,
        upc: item.upc,
        liner_size: item.liner_size,
        serial_required: item.serial_required,
        cross_sell_family: item.cross_sell_family,
        meta: item.meta,
        product_category: item.product_category,
        status: item.status,
      };
    });

    function customSuperFilter(array, term) {
      if (term) {
        var regexes = $.Enumerable.From(RegExp.escape(term).split(' '))
          .Select(function (t) {
            var regex = new RegExp(['.*?', t, '.*?'].join(''));
            regex.compile(regex.source, 'im');
            return regex;
          })
          .ToArray();
        return $.grep(array, function (value) {
          var testOn = value.label || value.value || value;
          return _(regexes).all(function (t) {
            return t.test(testOn);
          });
        });
      } else {
        return array;
      }
    }

    function customFilter(array, terms) {
      const arrayOfTerms = terms.split(' ');
      var term = $.map(arrayOfTerms, function (tm) {
        return $.ui.autocomplete.escapeRegex(tm);
      }).join('.*?');

      var matcher = new RegExp(term, 'i');
      return $.grep(array, function (value) {
        return (
          matcher.test(value.sku) || matcher.test(value.upc) || matcher.test(value.meta) || matcher.test(value.name)
        );
      });
    }

    function custom_source(request, response) {
      var stripTerm = request.term.replace('trash', '');
      response(customFilter(products, stripTerm));
    }

    $('#productSelector').focus(function () {
      if ($('#modelUPC').val() == '') {
        $(this).autocomplete('search', $(this).val());
      }
    });

    $('#productSelector').blur(function () {
      if ($('#modelUPC').val() == '') {
        $('#modelSKU').val('');
        $('#productNameReg').val('');
        $('#linerSize').val('');
        $('#error_modelUPC').text(error_item_partial);
        $('#error_modelUPC').show();
      } else {
        $('#error_modelUPC').text('');
        $('#error_modelUPC').hide();
      }
    });

    $('#productSelector')
      .autocomplete({
        source: custom_source,
        minLength: 0,
        autoFocus: true,
        select: function (event, ui) {
          $('#productSelector').val(ui.item.sku + ' ' + ui.item.name);
          $('#modelUPC').val(ui.item.sku + ' ' + ui.item.name);
          $('#modelSKU').val(ui.item.sku);
          $('#warrantyYears').val(ui.item.warranty_years);
          // if element id "productImage" exists, then set the image
          if ($('#productImage').length) {
            $('#productImage').attr('src', '//s3cdn.simplehuman.com/media/main_images/main-' + ui.item.sku + '.jpg');
            // show element
            $('#divProductImageWrapper').show();
          }
          $('#productNameReg').val(ui.item.name);
          // html of #divProductName set
          $('#divProductName').html(ui.item.name);
          if ($('#serialNumberLocationImage').length) {
            let location_identifier = 'trash_can';
            // if ui.item.name contains "compact"
            if (ui.item.name.toLowerCase().indexOf('compact') >= 0) {
              location_identifier = 'compact_mirror';
            } else if (ui.item.name.toLowerCase().indexOf('mirror') >= 0) {
              location_identifier = 'mirror';
            } else if (ui.item.name.toLowerCase().indexOf('commercial') >= 0) {
              location_identifier = 'commercial_can';
            } else if (ui.item.name.toLowerCase().indexOf('pump') >= 0) {
              location_identifier = 'pump';
            } else if (ui.item.name.toLowerCase().indexOf('liner pocket') >= 0) {
              location_identifier = 'liner_pocket_can';
            }
            $('#serialNumberLocationImage').attr(
              'src',
              '//cdn.shopify.com/s/files/1/2804/6630/files/serial_number_location-' + location_identifier + '-fpo.jpg'
            );
            // show element
            $('#divSerialNumberLocationWrapper').show();
          }

          $('#linerSize').val(ui.item.liner_size);
          if (ui.item.product_category) {
            $('#productType').val(ui.item.product_category);
          } else if (ui.item.liner_size != '') {
            $('#productType').val('Can');
          } else {
            $('#productType').val('other');
          }
          if (ui.item.serial_required == 'Yes') {
            $('#serialNumber').val('');
            $('.serialCol').css('display', 'inline');
            $('#serialNumber').attr({
              pattern: '[b|p|g|l|s|t|a|B|P|G|L|S|T|A]{1}[0-9]{8}',
              title: serial_number_format,
            });
          } else {
            $('#serialNumber').removeAttr('pattern');
            $('#serialNumber').removeAttr('title');
            $('.serialCol').css('display', 'none');
            $('#serialNumber').val('N/A');
          }
          return false;
        },
        response: function (event, ui) {
          // ui.content is the array that's about to be sent to the response callback.
          if (ui.content.length === 0) {
            $('#error_modelUPC').text(error_item_empty).show();
            //$("#findProduct").text("product finder");
            $('#findProduct').show();
          } else {
            $('#error_modelUPC').hide();
            $('#error_modelUPC').empty();
          }
        },
        change: function (event, ui) {
          //        console.log(this.value);
          if (ui.item == null) {
            $('#modelUPC').val('');
            $('#modelSKU').val('');
            $('#warrantyYears').val('');
            $('#productNameReg').val('');
            $('#linerSize').val('');
            $('#error_modelUPC').text(error_item_partial);
            $('#error_modelUPC').show();
          } else {
            $('#error_modelUPC').text('');
            $('#error_modelUPC').hide();
          }
        },
        classes: {
          'ui-autocomplete': 'ui-product-data',
        },
      })
      .data('uiAutocomplete')._renderItem = function (ul, item) {
      return $('<li></li>')
        .data('item.autocomplete', item)
        .append(
          '<a><img src="//s3cdn.simplehuman.com/media/main_images/main-' +
            item.sku.substring(0, 6) +
            '.jpg" width="50"/><span style="display:inline-block;height:20px;margin:0px 6px;">' +
            item.sku +
            ' <br/>' +
            item.name +
            '<br/> (UPC ' +
            item.upc +
            ')' +
            '</span></a>'
        )
        .appendTo(ul);
    };
  });
};
/* eslint-enable */

const getProductData = (show_discount = false) => {
  if ($('.template-collection-warranty').length !== 0) {
    // console.warn('getProductData.js is not needed on the warranty page');

    if (!window.sessionStorage.getItem('sh_rnactive')) {
      // console.warn('getProductData.js no sessionStorage for sh_rnactive. Redirect to account!');
      window.location.href = `${window.theme.local_subfolder}/account?view=registrations`;
      return;
    }

    $('input[name="warrantyRegistrationNumber"]').val(window.sessionStorage.getItem('sh_rnactive'));

    return;
  }

  //  console.log('getProductData');
  const product_data = `${window.theme.registration_feed_url}?nocache=${new Date().getTime()}`;
  generateProductDD(product_data);

  const newsletter_signup = document.querySelector('#newsletter_signup').textContent;
  const percent_off_message = document.querySelector('#percent_off_message').textContent;
  const with_this_registration = document.querySelector('#with_this_registration').textContent;

  const url = `${window.theme.sh_webform_url}`;

  /* eslint-disable */
  $('#serialNumber')
    .focusout(function () {
      var regSerialNumber = /[b|p|g|l|s|t|a|B|P|G|L|S|T|A]{1}[0-9]{8}/;
      if (!regSerialNumber.test($(this).val())) {
        if (window.theme.enable_new_registration_flow) {
          $('#addToEmailListCopy').hide();
        } else {
          $('#addToEmailListCopy').html(newsletter_signup);
        }
      } else if (show_discount) {
        if (window.theme.enable_new_registration_flow) {
          $('#addToEmailListCopy').html('<span class="Text-Style--bold">' + percent_off_message + '</span> ');
        } else {
          $('#addToEmailListCopy').html(
            '<span class="Text-Style--bold">' + percent_off_message + '</span> ' + with_this_registration
          );
        }
      }
    })
    .trigger('focusout');

  const setAutocomplete = (autocompleteId, valuetoset) => {
    $(autocompleteId).val(valuetoset);
    $(autocompleteId).autocomplete('search', valuetoset);
    const list = $(autocompleteId).autocomplete('widget');
    $(list[0].children[0]).trigger('click');
  };

  $('#productSelector').focusout(function () {
    let firstWord = $('#productSelector').val().split(' ')[0];
    if ($('#modelSKU').val() != firstWord) {
      //      console.log($('#modelSKU').val());
      //      console.log($('#productSelector').val());
      setAutocomplete('#productSelector', $('#productSelector').val());
    }
  });

  setTimeout(() => {
    if ($('#productSelector').val() !== '') {
      setAutocomplete('#productSelector', $('#productSelector').val());
    }
  }, 750);
};

const init = ($container = $(document)) => {
  console.log('Product Registration init');
  // console.log('Product Registration init: NEW FLOW');

  if (window.theme.enable_new_registration_flow) {
    setBindingsNewFlow($container);

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' && event.target.nodeName === 'INPUT') {
        // const form = event.target.form;
        // const index = Array.prototype.indexOf.call(form, event.target);
        event.target.blur();
        // form.elements[index + 1].focus();
        event.preventDefault();
      }

      return null;
    });
  } else {
    // console.log('Product Registration init: OLD FLOW');
    setBindings($container);
  }

  datepicker($container);
  let showDiscount = true;
  const form = document.querySelector('#webForm');

  new URL(document.location).searchParams.forEach((x, y) => {
    if (form.querySelector(`[name="${y}"]`)) {
      form.querySelector(`[name="${y}"]`).value = x.trim();
    }
  });

  if (window.theme.country_code === 'AU') {
    showDiscount = false;
    getProductData(showDiscount);
  } else if (window.theme.country_code !== 'JP' && !window.theme.enable_new_registration_flow) {
    getProductData(showDiscount);
  }
};

init();
